<div class="modal-header">
  <h5 class="modal-title">{{title }}</h5>
  <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
    (click)="modale.close('ferme')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="d-flex">
    <!-- COL GAUCHE -->
    <div class="flex-fill">
      <p>
        <span class="title-show">Référence : </span>
        <span class="title-result-show">{{ folder?.code }}</span>
      </p>
      <p>
        <span class="title-show">Client : </span>
        <span class="title-result-show">{{ folder?.customer?.nom }}</span>
      </p>
      <p>
        <span class="title-show">Chargé d'affaire : </span>
        <span class="title-result-show">
          <span class="badge badge">{{ folder?.charge?.nom }}</span>
        </span>
      </p>
      <p>
        <span class="title-show">Date de création : </span>
        <span class="title-result-show">{{ folder?.date|date: "d MMMM y" : '' : 'fr-FR' }}</span>
      </p>
    </div>
    <!-- COL MILIEU -->
    <div class="flex-fill">
      <p>
        <span class="title-show">État : </span>
        <span class="title-result-show">
          <span class="badge badge-{{folder?.etat === 'VALIDE' ? 'success' : 'danger'}}"> {{ validation(folder?.etat) }} </span>
        </span>
      </p>
      <p>
        <span class="title-show">Montant : </span>
        <span class="title-result-show text-warning">{{ folder?.montant |number }} {{ global.device }}</span>
      </p>
      <p>
        <span class="title-show">Avance : </span>
        <span class="title-result-show text-warning">{{ folder?.montantAvance |number }} {{ global.device }}</span>
      </p>
      <p>
        <span class="title-show">Frais de dossier : </span>
        <span class="title-result-show text-warning">{{ folder?.montantFrais |number }} {{ global.device }}</span>
      </p>
      <p>
        <span class="title-show">Caution : </span>
        <span class="title-result-show text-warning">{{ folder?.caution |number }} {{ global.device }}</span>
      </p>
      <!-- NOUVEAU: Affichage des apports supplémentaires -->
      <p *ngIf="totalApportsSupplementaires > 0">
        <span class="title-show">Apports supplémentaires : </span>
        <span class="title-result-show text-info">
          <i class="fas fa-plus-circle"></i>
          {{ totalApportsSupplementaires |number }} {{ global.device }}
        </span>
      </p>
    </div>
    <!-- COL DROITE -->
    <div class="flex-fill">
      <p>
        <span class="title-show">Motif : </span>
        <span class="title-result-show">
          <span class="badge badge">{{ folder?.motif == 'PROPRIÉTAIRE' ? 'Bien en vente': folder?.motif}}</span>
        </span>
      </p>
      <p>
        <span class="title-show">Modalité : </span>
        <span class="title-result-show">{{ folder?.modalite }}</span>
        <span *ngIf="isProgressif" class="badge badge-warning ml-1">
          <i class="fas fa-chart-line"></i> Progressif
        </span>
      </p>
      <p *ngIf="folder?.modalite === 'ECHEANCE'" >
        <span class="title-show">Nombre de mois : </span>
        <span class="title-result-show">{{ folder?.nbrMois }}</span>
      </p>
      <p>
        <span class="title-show">Crée le : </span>
        <span class="title-result-show">{{ folder?.createdAt|date: "d MMMM y 'à' h:mm:ss" : '' : 'fr-FR' }}</span>
        <span class="title-show ml-5"> Par : </span>
        <span class="title-result-show">{{ folder?.create }}</span>
      </p>
      <p>
        <span class="title-show">Modifié le : </span>
        <span class="title-result-show">{{ folder?.updatedAt|date: "d MMMM y 'à' h:mm:ss" : '' : 'fr-FR'}}</span>
        <span class="title-show ml-5"> Par : </span>
        <span class="title-result-show">{{ folder?.update }}</span>
      </p>
    </div>
  </div>

  <div class="row">
    <!-- TABLEAU DES LOTS ET ILOTS -->
    <div class="col-md-12">
      <div class="row mb-2">
        <span class="badge badge-secondary my-2 mr-1 f-14 formBadge width">
          Détails des lots et ilots
        </span>
      </div>
      <div class="row mr-1">
        <div class="table-responsive">
          <table class="table table-sm table-striped table-bordered nowrap table-hover">
            <thead class="thead-light">
              <tr>
                <th>Lot / Ilot</th>
                <th>Prix U.</th>
                <th>Qte</th>
                <th>Tva</th>
                <th>Remise</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of folder?.houses">
                <td>{{item?.libelle ? item?.libelle : item?.labe}}</td>
                <td>{{item?.prix | number }} {{global.device}}</td>
                <td>{{item?.qte }}</td>
                <td>{{item?.tva }} %</td>
                <td>{{item?.remise }}</td>
                <td>{{item.total | number}} {{global.device}} </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="font-weight-bold font-size-40 text-right">Total</td>
                <td class="font-weight-bold font-size-40 text-danger"> {{ folder?.montantBien | number}} {{global.device}}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="folder?.options.length > 0">
    <!-- TABLEAU DES SUPPLEMENTS -->
    <div class="col-md-12">
      <div class="row mb-2">
        <span class="badge badge-secondary my-2 mr-1 f-14 formBadge width">
          Détails sur le supplément
        </span>
      </div>
      <div class="row mr-1">
        <div class="table-responsive">
          <table class="table table-sm table-striped table-bordered nowrap table-hover">
            <thead class="thead-light">
              <tr>
                <th>Désignation</th>
                <th>Prix u.</th>
                <th>Qte</th>
                <th>Tva</th>
                <th>Remise</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of folder?.options" >
                <td><p class="m-0 d-inline-block align-middle font-16">{{item?.libelle}}</p></td>
                <td>
                  <p class="m-0 d-inline-block align-middle font-30"><span class="font-weight-blod">{{item?.prix|number}} {{global.device}}</span></p>
                </td>
                <td>{{item?.qte}}</td>
                <td>{{item?.tva}} %</td>
                <td><p class="m-0 d-inline-block align-middle font-30"><span class="font-weight-blod">{{item?.remise|number}} {{global.device}}</span></td>
                <td><p class="m-0 d-inline-block align-middle font-30"><span class="font-weight-blod">{{(item?.total)|number}} {{global.device}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- NOUVEAU: TABLEAU DES APPORTS SUPPLÉMENTAIRES -->
  <div class="row" *ngIf="apportsSupplementaires.length > 0 || peutAjouterApport()">
    <div class="col-md-12">
      <div class="row mb-2 d-flex justify-content-between align-items-center">
        <div>
          <span class="badge badge-info my-2 mr-1 f-14 formBadge">
            <i class="fas fa-plus-circle"></i>
            Apports supplémentaires
            <span *ngIf="apportsSupplementaires.length > 0" class="badge badge-light ml-1">
              {{apportsSupplementaires.length}}
            </span>
          </span>
        </div>
        <div *ngIf="peutAjouterApport()">
          <button 
            type="button" 
            class="btn btn-sm btn-success" 
            (click)="ouvrirModalApport()"
            title="Ajouter un nouvel apport supplémentaire"
          >
            <i class="fas fa-plus"></i> Nouvel apport
          </button>
        </div>
      </div>

      <!-- Message si aucun apport -->
      <div *ngIf="apportsSupplementaires.length === 0 && !isLoadingApports" class="alert alert-info">
        <i class="fas fa-info-circle"></i>
        Aucun apport supplémentaire enregistré pour ce dossier.
      </div>

      <!-- Loader -->
      <div *ngIf="isLoadingApports" class="text-center py-3">
        <i class="fas fa-spinner fa-spin"></i> Chargement des apports...
      </div>

      <!-- Tableau des apports -->
      <div class="row mr-1" *ngIf="apportsSupplementaires.length > 0">
        <div class="table-responsive">
          <table class="table table-sm table-striped table-bordered nowrap table-hover">
            <thead class="thead-light">
              <tr>
                <th>Date</th>
                <th>Montant</th>
                <th>Type de recalcul</th>
                <th>Impact</th>
                <th>Économie</th>
                <th>État</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let apport of apportsSupplementaires">
                <td>
                  <small class="text-muted">
                    {{ apport.createdAt | date: "dd/MM/y 'à' HH:mm" : '' : 'fr-FR' }}
                  </small>
                </td>
                <td>
                  <strong class="text-info">
                    {{ apport.montantApport | number }} {{ global.device }}
                  </strong>
                </td>
                <td>
                  <span class="badge badge-light">
                    {{ getLibelleChoixRecalcul(apport.choixRecalcul) }}
                  </span>
                </td>
                <td>
                  <div *ngIf="apport.choixRecalcul === 'REDUIRE_DUREE'">
                    <small class="text-success">
                      <i class="fas fa-calendar-minus"></i>
                      -{{ apport.ancienneDuree - apport.nouvelleDuree }} mois
                    </small>
                  </div>
                  <div *ngIf="apport.choixRecalcul === 'REDUIRE_MENSUALITE'">
                    <small class="text-success">
                      <i class="fas fa-arrow-down"></i>
                      -{{ (apport.ancienneMensualite - apport.nouvelleMensualite) | number }} {{ global.device }}/mois
                    </small>
                  </div>
                </td>
                <td>
                  <span *ngIf="apport.economieTotal" class="text-success">
                    <i class="fas fa-piggy-bank"></i>
                    {{ apport.economieTotal | number }} {{ global.device }}
                  </span>
                  <span *ngIf="!apport.economieTotal" class="text-muted">-</span>
                </td>
                <td>
                  <span class="badge" [ngClass]="getBadgeClassApport(apport)">
                    {{ getEtatApportText(apport) }}
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot *ngIf="totalApportsSupplementaires > 0">
              <tr class="table-info">
                <td colspan="5" class="font-weight-bold text-right">
                  Total des apports actifs :
                </td>
                <td class="font-weight-bold text-info">
                  {{ totalApportsSupplementaires | number }} {{ global.device }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="folder?.echeances.length > 0">
    <!-- TABLEAU DES ECHEANCIERS -->
    <div class="col-md-12">
      <div class="row mb-2">
        <span class="badge badge-secondary my-2 mr-1 f-14 formBadge width">
          Détails des échéanciers
          <span *ngIf="folder?.typeEcheancier === 'PROGRESSIF'" class="badge badge-warning ml-1">
            <i class="fas fa-chart-line"></i> Progressif
          </span>
          <span *ngIf="totalApportsSupplementaires > 0" class="badge badge-light ml-1" title="Échéancier modifié par apports supplémentaires">
            <i class="fas fa-edit text-info"></i>
          </span>
        </span>
      </div>

      <!-- INFO PROGRESSIF -->
      <div *ngIf="folder?.typeEcheancier === 'PROGRESSIF'" class="alert alert-warning py-2 mb-2">
        <i class="fas fa-chart-line mr-1"></i>
        <strong>Échéancier progressif :</strong>
        +{{ (folder?.tauxProgression * 100) | number:'1.0-0' }}% tous les {{ (folder?.intervalleProgression / 12) | number:'1.0-0' }} ans
      </div>

      <!-- SECTION 1 : ANCIEN ÉCHÉANCIER (pliable, masqué à l'impression) -->
      <div *ngIf="totalApportsSupplementaires > 0" class="row mr-1 mb-3 d-print-none">
        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="cursor-pointer" (click)="showAncienEcheancier = !showAncienEcheancier">
              <i class="fas" [ngClass]="showAncienEcheancier ? 'fa-chevron-down' : 'fa-chevron-right'" class="mr-2 text-muted"></i>
              <span class="font-weight-bold text-muted">
                <i class="fas fa-history mr-1"></i> Ancien échéancier
                <span *ngIf="echeancesPayees.length > 0">({{echeancesPayees.length}} échéances payées)</span>
              </span>
            </div>
            <button class="btn btn-sm btn-outline-secondary" (click)="printerEcheancier('ANCIEN')" title="Imprimer l'ancien échéancier (avant apport)">
              <i class="fas fa-print mr-1"></i> Imprimer ancien échéancier
            </button>
          </div>
          <div *ngIf="showAncienEcheancier">
            <!-- Résumé des apports -->
            <div class="alert alert-info py-2 mb-2" *ngFor="let apport of apportsSupplementaires">
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Apport de <strong>{{apport.montantApport | number}} {{global.device}}</strong>
                — Ancienne mensualité : <strong>{{apport.ancienneMensualite | number}} {{global.device}}</strong>
                — Ancienne durée : <strong>{{apport.ancienneDuree}} mois</strong>
              </small>
            </div>
            <!-- Tableau des échéances payées si existantes -->
            <div *ngIf="echeancesPayees.length > 0" class="table-responsive">
              <table class="table table-sm table-bordered nowrap table-hover">
                <thead class="thead-light">
                  <tr>
                    <th>Description</th>
                    <th>Loyer équivalent</th>
                    <th>Charge</th>
                    <th>Montant</th>
                    <th>Capital Restant</th>
                    <th *ngIf="isProgressif">Loyer progressif</th>
                    <th *ngIf="isProgressif">Amortissement</th>
                    <th>État</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of echeancesPayees">
                    <td>{{item?.description}}</td>
                    <td>{{item.mensualiteBase | number}} {{global.device}}</td>
                    <td>{{item.charge | number}} {{global.device}}</td>
                    <td>{{item.montant | number}} {{global.device}}</td>
                    <td>{{(isProgressif ? item.capitalRestantProgressif : item.capitalRestant) | number}} {{global.device}}</td>
                    <td *ngIf="isProgressif">{{item.loyerProgressif | number}} {{global.device}}</td>
                    <td *ngIf="isProgressif">{{item.amortissementProgressif | number}} {{global.device}}</td>
                    <td><span class="badge badge-success">{{item.etat}}</span></td>
                  </tr>
                </tbody>
                <tfoot class="thead-light">
                  <tr class="font-weight-bold">
                    <td>Sous-total ({{echeancesPayees.length}} échéances)</td>
                    <td>{{totalMensualiteBasePayees | number}} {{global.device}}</td>
                    <td>{{totalChargePayees | number}} {{global.device}}</td>
                    <td>{{totalMontantPayees | number}} {{global.device}}</td>
                    <td></td>
                    <td *ngIf="isProgressif"></td>
                    <td *ngIf="isProgressif"></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <p *ngIf="echeancesPayees.length === 0" class="text-muted ml-3">
              <i class="fas fa-info-circle mr-1"></i> Aucune échéance payée. Utilisez le bouton "Imprimer ancien échéancier" pour générer le plan avant apport.
            </p>
          </div>
        </div>
      </div>

      <!-- SECTION 2 : ÉCHÉANCIER EN VIGUEUR (pliable, visible à l'impression) -->
      <div class="row mr-1">
        <div class="col-md-12">
          <!-- En-tête pliable seulement si apports existent -->
          <div *ngIf="totalApportsSupplementaires > 0" class="d-flex align-items-center justify-content-between mb-2 d-print-none">
            <div class="cursor-pointer" (click)="showNouveauEcheancier = !showNouveauEcheancier">
              <i class="fas" [ngClass]="showNouveauEcheancier ? 'fa-chevron-down' : 'fa-chevron-right'" class="mr-2 text-info"></i>
              <span class="font-weight-bold text-info">
                <i class="fas fa-calendar-check mr-1"></i> Échéancier en vigueur ({{echeancesImpayees.length}} échéances restantes)
              </span>
            </div>
            <button class="btn btn-sm btn-outline-info" (click)="printerEcheancier('VIGUEUR')" title="Imprimer l'échéancier en vigueur">
              <i class="fas fa-print mr-1"></i> Imprimer
            </button>
          </div>
          <div *ngIf="showNouveauEcheancier || totalApportsSupplementaires === 0">
            <div class="table-responsive">
              <table class="table table-sm table-striped table-bordered nowrap table-hover">
                <thead class="thead-light">
                  <tr>
                    <th>Description</th>
                    <th>Loyer équivalent</th>
                    <th>Cumul loyers</th>
                    <th>Capital restant</th>
                    <th *ngIf="isProgressif">Loyer progressif</th>
                    <th *ngIf="isProgressif">Cumul (prog.)</th>
                    <th *ngIf="isProgressif">Amortissement</th>
                    <th *ngIf="isProgressif">Amort. cumulé</th>
                    <th>État</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Si pas d'apport, afficher toutes les échéances -->
                  <ng-container *ngIf="totalApportsSupplementaires === 0">
                    <tr *ngFor="let item of folder?.echeances">
                      <td>{{item?.description}}</td>
                      <td>{{item.mensualiteBase | number}} {{global.device}}</td>
                      <td>{{(isProgressif ? item.cumulProgressif : item.cumulPaiements) | number}} {{global.device}}</td>
                      <td>{{(isProgressif ? item.capitalRestantProgressif : item.capitalRestant) | number}} {{global.device}}</td>
                      <td *ngIf="isProgressif">{{item.loyerProgressif | number}} {{global.device}}</td>
                      <td *ngIf="isProgressif">{{item.cumulProgressif | number}} {{global.device}}</td>
                      <td *ngIf="isProgressif">{{item.amortissementProgressif | number}} {{global.device}}</td>
                      <td *ngIf="isProgressif">{{item.cumulAmortissement | number}} {{global.device}}</td>
                      <td>
                        <span class="badge" [ngClass]="{'badge-success': item.etat === 'PAYE', 'badge-warning': item.etat === 'IMPAYE'}">
                          {{item.etat}}
                        </span>
                      </td>
                    </tr>
                  </ng-container>
                  <!-- Si apport, afficher seulement les échéances restantes -->
                  <ng-container *ngIf="totalApportsSupplementaires > 0">
                    <tr *ngFor="let item of echeancesImpayees">
                      <td>{{item?.description}}</td>
                      <td>{{item.mensualiteBase | number}} {{global.device}}</td>
                      <td>{{(isProgressif ? item.cumulProgressif : item.cumulPaiements) | number}} {{global.device}}</td>
                      <td>{{(isProgressif ? item.capitalRestantProgressif : item.capitalRestant) | number}} {{global.device}}</td>
                      <td *ngIf="isProgressif">{{item.loyerProgressif | number}} {{global.device}}</td>
                      <td *ngIf="isProgressif">{{item.cumulProgressif | number}} {{global.device}}</td>
                      <td *ngIf="isProgressif">{{item.amortissementProgressif | number}} {{global.device}}</td>
                      <td *ngIf="isProgressif">{{item.cumulAmortissement | number}} {{global.device}}</td>
                      <td>
                        <span class="badge" [ngClass]="{'badge-warning': item.etat === 'IMPAYE' || item.etat === 'ATTENTE'}">
                          {{item.etat}}
                        </span>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tfoot class="thead-light">
                  <tr class="font-weight-bold" *ngIf="totalApportsSupplementaires === 0">
                    <td>Total ({{folder?.echeances?.length}} échéances)</td>
                    <td>{{totalMensualiteBase | number}} {{global.device}}</td>
                    <td></td>
                    <td></td>
                    <td *ngIf="isProgressif">{{totalLoyerProgressif | number}} {{global.device}}</td>
                    <td *ngIf="isProgressif"></td>
                    <td *ngIf="isProgressif"></td>
                    <td *ngIf="isProgressif"></td>
                    <td></td>
                  </tr>
                  <tr class="font-weight-bold" *ngIf="totalApportsSupplementaires > 0">
                    <td>Total ({{echeancesImpayees.length}} échéances)</td>
                    <td>{{totalMensualiteBaseImpayees | number}} {{global.device}}</td>
                    <td></td>
                    <td></td>
                    <td *ngIf="isProgressif"></td>
                    <td *ngIf="isProgressif"></td>
                    <td *ngIf="isProgressif"></td>
                    <td *ngIf="isProgressif"></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="folder?.advances.length > 0">
    <!-- TABLEAU DES AVANCES -->
    <div class="col-md-12">
      <div class="row mb-2">
        <span class="badge badge-secondary my-2 mr-1 f-14 formBadge width">
          Détails des avancements
        </span>
      </div>
      <div class="row mr-1">
        <div class="table-responsive">
          <table class="table table-sm table-striped table-bordered nowrap table-hover">
            <thead class="thead-light">
              <tr>
                <th>Libellé</th>
                <th>Pourcentage (%)</th>
                <th>État</th>
                <th>Montant</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of folder?.advances" >
                <td>{{item?.libelle }}</td>
                <td>{{item.prc}} %</td>
                <td>{{item.etat}}</td>
                <td>{{item.montant | number}} {{global.device}} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <table class="table table-responsive  invoice-table invoice-total">
        <tbody>
          <tr>
            <th>Total ht : </th>
            <td> {{ folder?.montantHt | number }} {{global.device}}</td>
          </tr>
          <tr>
            <th>Total remise : </th>
            <td> {{ folder?.remise | number }} {{global.device}}</td>
          </tr>
          <tr>
            <th>Tatal tva : </th>
            <td> {{ folder?.montantTva | number }} {{global.device}}</td>
          </tr>
          <tr *ngIf="totalApportsSupplementaires > 0" class="table-info">
            <th><i class="fas fa-plus-circle"></i> Total apports supplémentaires : </th>
            <td class="text-info font-weight-bold"> {{ totalApportsSupplementaires | number }} {{global.device}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <table class="mb-2 width">
    <tbody>
      <tr class="border-bottom-success">
        <td></td>
        <td colspan="5" class="text-right font-weight-bold"></td>
      </tr>
    </tbody>
    <tfoot>
      <tr class="border border-success">
        <td colspan="5" class="font-weight-bold font-size-default">Total</td>
        <td class="font-weight-bold font-size-default text-right">{{ folder?.montant | number }} {{global.device}}</td>
      </tr>
      <tr *ngIf="totalApportsSupplementaires > 0" class="border border-info">
        <td colspan="5" class="font-weight-bold font-size-default text-info">
          <i class="fas fa-calculator"></i> Capital restant effectif
        </td>
        <td class="font-weight-bold font-size-default text-right text-info">
          {{ (folder?.montant - folder?.montantAvance - totalApportsSupplementaires) | number }} {{global.device}}
        </td>
      </tr>
    </tfoot>
  </table>

  <div class="row mb-2">
    <div class="col-md">
      <span class="badge badge-secondary mb-2 f-14 width">Fiche de dossier</span>
      <div class="row">
        <div [ngClass]="file ? 'col-md-4' : 'col-md-12'">
          <app-folder-uploader (click)="showFile(folder?.folder)" [maxSize]="3"
            [folder]="folder?.folder"
            [etat]="'show'"
            [allowFileUpload]="false" [allowDownload]="true">
          </app-folder-uploader>
        </div>
        <div [ngClass]="file ? 'col-md-8' : ''"  *ngIf="file" >
          <div class="row">
            <div class="col-sm-12 mb-2">
              <button (click)="closeViewer()" type="button" class="btn btn-secondary m-1">
                <i class="fa fa-arrow-alt-circle-left"></i> Fermer
              </button>
            </div>
          </div>
          <ngx-doc-viewer
            [url]="file"
            viewer="url" style="width:100%;height: 64vh;">
          </ngx-doc-viewer>

        </div>
      </div>

    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="modale.close('ferme')" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
    Fermer <i class="feather icon-x-circle"></i>
  </button>
  <button *ngIf="folder?.etat === 'INVALIDE'" (click)="editFolder(folder)" class="btn btn-primary">
    Modifier <i class="feather icon-edit-2"></i>
  </button>
  <button *ngIf="folder?.etat === 'VALIDE'" (click)="printerFolder(folder)" class="btn btn-warning">
    Imprimer <i class="feather icon-printer"></i>
  </button>
  <button *ngIf="folder?.etat === 'VALIDE' && folder?.modalite === 'ECHEANCE'" (click)="printerAmortissement()" class="btn btn-success">
    Amortissement <i class="fas fa-table"></i>
  </button>
  <button *ngIf="peutConvertirEnProgressif()" (click)="convertirEnProgressif()" class="btn btn-warning"
    [disabled]="isConverting" title="Convertir l'échéancier constant en loyers progressifs">
    <i class="fas" [ngClass]="isConverting ? 'fa-spinner fa-spin' : 'fa-chart-line'"></i>
    {{ isConverting ? 'Conversion...' : 'Convertir en progressif' }}
  </button>
  <button *ngIf="peutConvertirEnAnnuel()" (click)="convertirEnAnnuel()" class="btn btn-warning"
    [disabled]="isConverting" title="Convertir le dossier COMPTANT en échéancier annuel">
    <i class="fas" [ngClass]="isConverting ? 'fa-spinner fa-spin' : 'fa-calendar-alt'"></i>
    {{ isConverting ? 'Conversion...' : 'Convertir en échéancier annuel' }}
  </button>
  <button *ngIf="peutAjouterApport()" (click)="ouvrirModalApport()" class="btn btn-info">
    <i class="fas fa-plus-circle"></i> Nouvel apport
  </button>
  <button *ngIf="folder?.customer" (click)="addWalletTransaction()" class="btn btn-info">
    <i class="fas fa-wallet"></i> Dépôt/Retrait wallet
  </button>

  <button *ngIf="validate && folder?.etat === 'INVALIDE'" (click)="activateFolder(folder)"  class="btn btn-success">
    Valider <i class="fas fa-check"></i>
  </button>
</div>